import { gql } from '@apollo/client';

export const COMPONENT_LIST_SET_PATCH = gql`
    mutation PatchComponentListSet( $input: PatchComponentListSetInput! ) {
        patchComponentListSet( input: $input ) {
            componentListSetId
            type
            name
            description
            isPublished
            componentLists
            createdAt
            updatedAt
        }
    }
`;

export default COMPONENT_LIST_SET_PATCH;
